import React from 'react';
import { Phone, X } from 'lucide-react';
import { companyInfo } from '../data/mock';

const FloatingCTA = () => {
  return (
    <>
      {/* Mobile Fixed Bottom CTA */}
      <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-lime-500 to-lime-400 p-4 md:hidden z-50 shadow-2xl">
        <a 
          href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
          className="flex items-center justify-center gap-3 text-gray-900 font-bold text-lg"
        >
          <Phone className="animate-pulse" size={24} />
          <span>Appeler maintenant</span>
        </a>
      </div>

      {/* Desktop Floating Button */}
      <a
        href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
        className="hidden md:flex fixed bottom-6 right-6 z-50 items-center gap-3 bg-lime-500 hover:bg-lime-400 text-gray-900 font-bold px-6 py-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group"
      >
        <Phone size={24} className="group-hover:animate-bounce" />
        <div className="pr-2">
          <p className="text-xs font-medium text-gray-700">Urgence 24h/24</p>
          <p className="text-lg font-bold">{companyInfo.phone}</p>
        </div>
      </a>
    </>
  );
};

export default FloatingCTA;